<template lang="pug">
div
  .d-none.d-md-block.concat-pop
    img.concat-img(v-show="isOpen",src="http://res.99ro.top/web-assets/concat_qqgroup.png")
    img.pop-icon(@click='toggle()',:src="'http://res.99ro.top/web-assets/img/icon-window-'+(isOpen?'min':'max')+'.png'")
</template>

<style lang="scss" scoped>
.concat-pop {
  position: fixed;
  bottom: 5%;
  left: 5%;
  z-index: 2;

  .concat-img {
    position: relative;
  }
}

.pop-icon {
  position: absolute;
  cursor: pointer;
  right: 0px;
  top: 0px;
  width: 25px;
  height: 25px;
}
</style>

<script>
/* global $ */
export default {
  name: 'Concat',
  data() {
    return {
      isOpen: true,
    };
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
  },
  created() {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/ConcatMessage.vue